/* Home auto-generated by npm run generator */
import { makeStyles, Theme } from "@material-ui/core"
import { PortalRole } from "@qlarity/common"
import { observer } from "mobx-react"
import React from "react"
import { generatePath, Redirect } from "react-router-dom"
import { PATHS, ROUTE_PATHS } from "Router"
import Store from "store/Store"
interface HomeProps {}

const useStyles = makeStyles((theme: Theme) => ({
    homePage: { backgroundColor: theme.palette.background.default, display: "grid", gridGap: theme.spacing(2) },
}))

const Home: React.FC<HomeProps> = (props) => {
    const classes = useStyles()

    console.log(Store.auth.authUser)

    switch (Store.auth.portalUser?.role) {
        case PortalRole.ADMIN:
            return <Redirect to={PATHS.ADMIN()} />
        case PortalRole.ORG_ADMIN:
            return <Redirect to={generatePath(ROUTE_PATHS.ORG, { orgId: Store.auth.portalUser?.orgId })} />
        case PortalRole.CLINICIAN:
            return <Redirect to={generatePath(ROUTE_PATHS.CLINICIAN, { orgId: Store.auth.portalUser?.orgId, clinicianId: Store.auth.authUser?.uid })} />
    }

    return <div className={classes.homePage}>User role not found</div>
}

export default observer(Home)
